import { useState, useEffect } from "react";

import TermsAcceptance from "./TermsAcceptance";
import { TopBarPageContainer } from "../../components/PageContainer";

import Footer from "./Footer";

import { LoadingSkeleton } from "@narmi/design_system";

export default function FunctionsContainer({ children }: React.PropsWithChildren) {
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function fetchTerms() {
      const resp = await fetch("/v1/product_terms?feature=narmi_functions");
      try {
        const json = await resp.json();
        setAcceptedTerms(json.accepted);
      } catch (e) {
        setAcceptedTerms(false);
      }
      setIsLoading(false);
    }
    fetchTerms();
  }, []);

  if (isLoading) {
    return (
      <TopBarPageContainer title="Narmi Functions">
        <div className="flex justify-center mt-8">
          <LoadingSkeleton />
        </div>
      </TopBarPageContainer>
    );
  }

  if (!acceptedTerms) {
    return (
      <TopBarPageContainer title="Narmi Functions">
        <TermsAcceptance />
      </TopBarPageContainer>
    );
  }

  return (
    <div>
      {children}
      <Footer />
    </div>
  );
}
